import React from 'react';
import { Helmet } from 'react-helmet-async';

// Reusable per-route document head. og:title / og:description default to title / description.
export const Seo = ({ title, description, ogTitle, ogDescription, ogImage }) => (
  <Helmet>
    {title && <title>{title}</title>}
    {description && <meta name="description" content={description} />}
    {(ogTitle || title) && <meta property="og:title" content={ogTitle || title} />}
    {(ogDescription || description) && (
      <meta property="og:description" content={ogDescription || description} />
    )}
    {ogImage && <meta property="og:image" content={ogImage} />}
  </Helmet>
);

export default Seo;
